import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as Mover from '../../../../../utils/Mover';
import SceneVideo from '../SceneVideo/SceneVideo';
import { MOVE_SCENE_Y, MOVE_Y, ASSETS_FOLDER } from '../../../../../constants';
import { SCENE_BOTTOM } from '../../../../../content';
import { setSceneVideo, soundBlocked } from '../../../../../redux/actions';
import * as SoundManager from '../../../../../utils/SoundManager';
import * as Features from '../../../../../utils/Features';
import './SceneBottom.css';
import SceneSpotGroup from '../../../../Shared/SceneSpotGroup/SceneSpotGroup';

class SceneBottom extends Component {
  constructor(props) {
    super(props);

    // ref
    this.sceneRef = React.createRef();

    // bind
    this.loop = this.loop.bind(this);
    this.handleSceneClick = this.handleSceneClick.bind(this);
  }

  // -------------------------------------------------------
  // Lifecycle
  // -------------------------------------------------------

  componentDidMount() {
    this.startLoop();
  }

  componentWillUnmount() {
    this.stopLoop();
  }

  // -------------------------------------------------------
  // Loop
  // -------------------------------------------------------

  loop() {
    const transY = Math.min(
      this.props.height * MOVE_Y * MOVE_SCENE_Y,
      -(Mover.getCenterOffsetY() * MOVE_SCENE_Y)
    );
    this.sceneRef.current.style.transform = `translateY(${transY}px)`;
    this.loopRef = window.requestAnimationFrame(this.loop);
  }

  startLoop() {
    if (!Features.features.mobile && !this.loopRef) {
      this.loopRef = window.requestAnimationFrame(this.loop);
    }
  }

  stopLoop() {
    window.cancelAnimationFrame(this.loopRef);
  }

  // -------------------------------------------------------
  // Click
  // -------------------------------------------------------

  handleSceneClick() {
    this.props.setSceneVideo('');
    // try to unmute sound
    if (this.props.sceneVideo === '' && this.props.soundBlockState === true) {
      this.props.soundBlocked(SoundManager.muteAtmo(false));
    }
  }

  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------

  render() {
    const {
      posX,
      scale,
      width,
      height,
      sceneVideo,
      sceneVideoPosition,
    } = this.props;

    // video vars
    const videoActive = sceneVideo.length > 0 && sceneVideoPosition === -1;
    const videoSource = videoActive ? sceneVideo : '';

    const scaleStyle = {
      top: -height * MOVE_Y * MOVE_SCENE_Y,
      transform: `scale(${scale})`,
    };

    // layer styles
    const styles = [];
    for (let i = 0; i < SCENE_BOTTOM.FIRE.length - 1; i += 1) {
      let opacity = 1;
      if (posX < SCENE_BOTTOM.FIRE[i + 1]) {
        opacity = Math.max(
          (posX - SCENE_BOTTOM.FIRE[i]) / (SCENE_BOTTOM.FIRE[i + 1] - posX),
          0
        );
      }
      styles.push({
        opacity,
      });
    }

    return (
      <div
        id="scene-bottom"
        style={{
          width: `${width}px`,
          height: `${height}px`,
        }}
      >
        <div
          className="scene-content"
          ref={this.sceneRef}
          onClick={this.handleSceneClick}
        >
          <div className="scene-wrap" style={scaleStyle}>
            <div id="bg-btm-wrap">
              <img
                className="bg-btm-layer"
                src={`${ASSETS_FOLDER}img/scene/btm/content-btm-base.jpg`}
                alt=""
              />
              <img
                className="bg-btm-layer fire"
                src={`${ASSETS_FOLDER}img/scene/btm/fire-0.png`}
                style={styles[0]}
                alt=""
              />
              <img
                className="bg-btm-layer fire"
                src={`${ASSETS_FOLDER}img/scene/btm/fire-1.png`}
                style={styles[1]}
                alt=""
              />
              <img
                className="bg-btm-layer fire"
                src={`${ASSETS_FOLDER}img/scene/btm/fire-2.png`}
                style={styles[2]}
                alt=""
              />
              <img
                className="bg-btm-layer fire"
                src={`${ASSETS_FOLDER}img/scene/btm/fire-3.png`}
                style={styles[3]}
                alt=""
              />
              <img
                className="bg-btm-layer fire"
                src={`${ASSETS_FOLDER}img/scene/btm/fire-4.png`}
                style={styles[4]}
                alt=""
              />
            </div>
          </div>
          <SceneSpotGroup type={-1} style={scaleStyle} />
        </div>
        <SceneVideo type="bottom" active={videoActive} source={videoSource} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  scale: state.ui.scale,
  height: state.ui.height,
  width: state.ui.width,
  sceneVideo: state.app.sceneVideo,
  sceneVideoPosition: state.app.sceneVideoPosition,
  soundBlockState: state.app.soundBlockState,
});

const mapDispatchToProps = dispatch => ({
  setSceneVideo: videoId => dispatch(setSceneVideo(videoId)),
  soundBlocked: soundBlockState => dispatch(soundBlocked(soundBlockState)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SceneBottom);



// WEBPACK FOOTER //
// ./src/components/App/Dukla/Scene/SceneBottom/SceneBottom.js